import {SET_TOTALCOMMENTS ,SET_FOLLOWUPSTATUS,SET_CASEID} from './totalCommentsDetailsAction';
const initialState = {
    totalCommentsData: '',
    caseId:'',
    followupstatus:''
};
const totalCommentsDetails = (state = initialState, action) => {
    switch (action.type) {
       
        case SET_TOTALCOMMENTS:
            return Object.assign({}, state, {
                totalCommentsData: action.value
            })
            case SET_CASEID:
            return Object.assign({}, state, {
                caseId: action.value
            })
            case SET_FOLLOWUPSTATUS:
            return Object.assign({}, state, {
                followupstatus: action.value
            })
        default:
            return state;
    }
}
export default totalCommentsDetails;